module.exports = __webpack_public_path__ + "img/selfie-camera.852ea355.svg";